export default __webpack_public_path__ + "static/media/rm373batch16-banner-09.4d5e3998.png";